import { getClient } from "config/apollo";

export const getApolloClient = () => getClient();
